import { type Ref } from 'react';
import { useAuth } from '@auth';
import { PaymentGatewayForm, type PaymentGatewayFormRef } from '@wallet';

interface Props {
  scheduleId: string;
  isFunded: boolean;
  onReady: () => void;
  onPaymentConfirmed: () => void;
  onError?: () => void;
  ref?: Ref<PaymentGatewayFormRef>;
}

export default function ActivationPayment({ ref, scheduleId, isFunded, onReady, onPaymentConfirmed, onError }: Props) {
  const { plan } = useAuth();

  const costCents = plan?.schedule_cost_cents ?? 0;

  if (isFunded) {
    return null;
  }

  return (
    <div className="mt-3 rounded-2xl border border-slate-200 bg-white/90">
      <PaymentGatewayForm
        ref={ref}
        amountCents={costCents}
        scheduleId={scheduleId}
        onPaymentConfirmed={onPaymentConfirmed}
        onReady={onReady}
        onError={onError}
      />
    </div>
  );
}
